import React from 'react';

interface IconProps {
  src: string;
  alt?: string;
  className?: string;
  size?: number;
}

export const Icon: React.FC<IconProps> = ({
  src,
  alt = '',
  className = '',
  size = 16
}) => {
  return (
    <img
      src={src}
      alt={alt}
      className={`inline-block ${className}`}
      style={{ width: `${size}px`, height: `${size}px` }}
    />
  );
};
